module.exports = __webpack_public_path__ + "img/programme3.82b35988.png";